var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"-my-2 -mx-4 overflow-x-auto sm:-mx-0 lg:-mx-0"},[_c('div',{staticClass:"inline-block min-w-full py-2 align-middle"},[_c('div',{staticClass:"overflow-hidden shadow-sm ring-1 ring-black ring-opacity-5"},[(_vm.isLoading)?_c('CompareListPlaceholder'):_c('CompareListTable')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }